module.exports = __webpack_public_path__ + "static/media/20151231_161515.6d7bbc70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20151231_161515.jpg
// module id = 448
// module chunks = 0